import React, {Component} from 'react';
import {connect} from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { InputGroup } from "react-bootstrap";
import Icons from '../../../../app/components/icon';
import { debounce } from 'throttle-debounce';
import AutoSuggestSpinner from '../../../../../src/img/icon-circuit-loader.gif';
import Translation from '../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../utils/constant.utils';
import './user-search.component.css';

const escapeRegexCharacters = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const getSuggestions = (value, userList) => {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
        return [];
    }

    const regex = new RegExp('\\b' + escapedValue, 'i');

    return userList.filter((user) => regex.test(getSuggestionValue(user)) || regex.test(getSuggestionValueEid(user)) || regex.test(getSuggestionValueFirstLastName(user))
                    || regex.test(getSuggestionValueLastFirstName(user)));
};

const theme = {
    suggestionsContainer: {
        position: 'absolute',
        zIndex: 1,
        background: '#fff',
        width: '100%',
        top: '40px',
        borderRadius: '4px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, .2)',
        border: '1px solid #ccc',
        maxHeight: '200px',
        overflowY: 'auto'
    },
    suggestionsList: {
        listStyle: 'none',
        margin: 0,
        padding: '10px ',
        paddingTop: '10px'
    }
};
const getSuggestionValue = (suggestion) => suggestion.FullName;
const getSuggestionValueEid = (suggestion) => suggestion.EId;
const getSuggestionValueFirstLastName = (suggestion) => suggestion.FirstLastName;
const getSuggestionValueLastFirstName = (suggestion) => suggestion.LastFirstName;

const renderSuggestion = (suggestion, { query }) => {
    const reg = new RegExp(query, 'gi');
    const fullName = suggestion.FullName.replace(reg, (match) => '<span class="highlight">' + matchCase(query, match) + '</span>');

    return (
        <div className="user-list-container">
            <p className="user-suggest-primary">
                <span dangerouslySetInnerHTML={{ __html: fullName }} />
            </p>
            <p className="user-suggest-secondary">{suggestion.EId}</p>
            <p className="user-suggest-secondary">{suggestion.Location}</p>
        </div>
    );
};

function matchCase(text, pattern) {
    var result = '';

    for (var i = 0; i < text.length; i++) {
        var c = text.charAt(i);
        var p = pattern.charCodeAt(i);

        if (p >= 65 && p < 65 + 26) {
            result += c.toUpperCase();
        } else {
            result += c.toLowerCase();
        }
    }

    return result;
}
class UserSearch extends Component {
    constructor() {
        super();

        this.state = {
            value: '',
            suggestions: [],
            isFetching: true,
            showSuggestions: true,
        };

        this.fetchOnDemandDebounced = debounce(500, this.fetchOnDemand);
    }
    containerRef = React.createRef();

    clearField = () => {
        this.setState({
            value: '',
        });
    };

    fetchOnDemand = (val) => {
        this._fetch(val);
    };

    _fetch = async (val) => {
        val = val.trim();

        var res = await this.props.searchAutosuggest(val);
        if (res != null) {
            res = res.map((a) => ({
                EmployeeId: a.EmployeeId,
                EId: a.Eid,
                FullName: a.Name,
                Location: a.LocationSiteCityCountry,
                FirstLastName: a.FirstLastName,
                LastFirstName: a.LastFirstName

            }));

            this.setState({
                suggestions: res,
            });
        }

        this.setState({
            isFetching: true,
        });       
    };

    onChange = (event, { newValue, method }) => {
        const showSuggestions = method === 'type';

        if (this.props.onDemandAction) {
            this.setState(
                {
                    value: newValue,
                    showSuggestions: showSuggestions,
                },
                () => {
                    if (showSuggestions) {
                        this.fetchOnDemandDebounced(this.state.value);
                    }
                }                
            );
        } else {
            this.setState({
                value: newValue,
                showSuggestions: showSuggestions
            });
        }
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(value, this.props.list),
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    onSuggestionSelected = (event, { suggestion }) => {
        this.props.action(suggestion);
    };

    renderSuggestionsContainer = ({ containerProps, children }) => {
        if (!this.state.showSuggestions || !children) return null;

        var searchValue = children.props.renderItemData.query;

        return (
            <div
                {...containerProps}
                onScroll={(e)=>this.handleSuggestionScroll(e, searchValue)}
            >
                {/*<div className="user-suggest-title">*/}
                {/*    <Translation translationKey="search_suggestions" />*/}
                {/*</div>*/}
                {children}
            </div>
        );
    };

    handleSuggestionScroll = async (e, searchValue) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;

        if (scrollTop + clientHeight >= scrollHeight - 5) {
            var res = await this.props.loadMoreAutosuggest(searchValue);
            if (res != null) {
                res = res.map((a) => ({
                    EmployeeId: a.EmployeeId,
                    EId: a.Eid,
                    FullName: a.Name,
                    Location: a.LocationSiteCityCountry,
                    FirstLastName: a.FirstLastName,
                    LastFirstName: a.LastFirstName

                }));

                this.setState({
                    suggestions: res,
                });
            }
        }
    };

   

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };
    render() {
        const { value, suggestions, isFetching } = this.state;
        const { onDemandAction, disable, maxLength } = this.props;
        const inputProps = {
            placeholder: this.toLocaleLanguage('enterSearchValue'),
            value,
            onChange: this.onChange,
            disabled: disable,
            maxLength: maxLength
        };

        return (
            <div id="user-search-bar" ref={this.containerRef} className={onDemandAction ? 'with-loader' : ''}>

                <InputGroup size="sm" className="mb-3 request-input-header">
                    <Icons name="search" containerClass="search-icon-container" customClassName="icon-search-auto-suggest" size="12px" />
                    <Autosuggest
                        theme={theme}
                        suggestions={isFetching ? suggestions : []}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        onSuggestionSelected={this.onSuggestionSelected}
                        getSuggestionValue={getSuggestionValue}
                        renderSuggestion={renderSuggestion}
                        renderSuggestionsContainer={this.renderSuggestionsContainer}
                        inputProps={inputProps}                       
                    />
                    <img hidden={isFetching} src={AutoSuggestSpinner} className="search-spinner-auto-suggest" alt="loader" />
                </InputGroup>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { translation } = state;
    return {
        ...translation,
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(UserSearch);
